import script from "./AudioOngoing.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioOngoing.vue?vue&type=script&setup=true&lang=js"

import "./AudioOngoing.vue?vue&type=style&index=0&id=1e06cde3&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e06cde3"]])

export default __exports__